<template>
  <div>
    <div class="columns" style="margin-bottom:0;margin-top: 29px;">
          <div class="column" style="display: block; text-align: left;padding-bottom: 0;">
            <b-button @click="gostep(1)" type="is-info" class="Filters cursor" style="float: inherit;margin-top:10px" id="Filters"  outlined>
              <span class="white" ><i class="fas fa-chevron-left"></i> Back</span>
            </b-button>
          </div>
    </div>


    <article>
      <div class="columns">
        <div
          class="column is-6-fullhd is-6-desktop is-6-tablet is-offset-3-fullhd is-offset-3-desktop is-offset-3-tablet"
        >
          <div class="get-started-transparent">
            <div>
              <div class="get-started-section">
                <div class="field is-grouped">
                  <div class="control is-expanded" style="text-align:center">
                    <div style="font-size:40px;color:#0D6ACA">
                      <i style="padding-right:5px;color:#0D6ACA" class="fas fa-comment-dots"></i>
                      จองเวลาผู้เชี่ยวชาญ
                    </div>
                  </div>
                </div>
                <div class="field is-grouped">
                     <div class="control is-expanded" style="text-align:center">
                    <div style="font-size:28px;color:#0D6ACA">
                        <br>
                   <b-button type="is-success" outlined>ปรึกษาผู้เชี่ยวชาญ {{ timebooking.slice(0,-6) }} นาที</b-button>
                    </div>
                  </div>
                </div>
                <div class="field is-grouped">
                     <div class="control is-expanded" style="text-align:center">
                         <br>
                         <br>
                         <br>
                         <div style="font-size:28px;color:#0D6ACA">
                      เลือกจำนวนเวลาที่ต้องการปรึกษาผู้เชี่ยวชาญ
                    </div>
                         <br>
                       <date-picker 
                       :range="false" 
                       v-model="datetime"
                       :lang="'en'"
                       :format="'DD-MM-YYYY'"
                       :first-day-of-week="1" 
                        type="datetime"
                       ></date-picker>
                  </div>
                </div>
                <div class="field is-grouped">
                     <div class="control is-expanded" style="text-align:center">
                    <div style="font-size:28px;color:#0D6ACA">
                    
                    <div class="fontblue" style="display:inline-block;margin:2px 2px">
                     <b-button @click="nextstep()" type="is-info" class="Filters" style="float: inherit;margin-top:10px" id="Filters"  outlined>
                            <span class="white" >ต่อไป</span>
                        </b-button>
                      </div>
                      
                    </div>
                  </div>
                </div>
           

              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import moment from "moment";
import DatePicker from 'vue2-datepicker'
export default {
   data() {
            return {
                datetime:''
    }
  },
  components:{
    DatePicker
  },
  methods: {
    gopath(val) {
      this.$router.push(val);
    },
    gostep(val){
         this.$store.commit('stepbooking',val)
    },
    nextstep(){
        if(!this.datetime){
               this.$dialog.alert('<p class="has-text-centered is-size-5">กรุณากรอกเวลาที่ต้องการปรึกษา</p>');
               return
        }
       var data =  moment(this.datetime).format('DD/MM/YYYY');
        this.$store.commit('stepbooking',3)
        this.$store.commit('datebooking',data)

    },
  },
  mounted() {

  },
    computed:{
        timebooking(){
           return this.$store.state.timebooking
      }
     
  },
};
</script>
<style scoped>
article{
  margin:0;
  border:1px solid #ebebeb;
  border-radius: 5px;
  background: white;
  padding: 1.8rem;
  position: relative;
  top: 23px;
}
#Filters.Filters{
  right: 1px;
  display:block;float:right;padding: 0 2rem;border:none;background: linear-gradient(180deg, #0D6ACA 0%, #0D6ACA 100%); border-radius: 40px;
}
#Filters.activefilter{
  border: 1px solid #0D6ACA !important;
  background: transparent !important;
}

#Filters.activefilter span,#Filters.activefilter i{
  color: #0D6ACA !important;
}

#Filters .white{
  color:white;
}
#Filters:hover{
  box-shadow: 0 0 0 1px #0D6ACA !important;
  /* border: 1px solid #0D6ACA !important; */
    background: transparent !important;
}

#Filters:hover .white,#Filters:hover i{
  color:#0D6ACA;
}
.cardbooking {
  margin-right: 5px;
  border: 1px solid #0d6aca;
  color: #0d6aca;
}
.circle span {
  color: white;
  font-weight: bold;
}
.blurbutton {
  padding: 5px 2rem;
  filter: blur(0px);
  position: absolute;
  z-index: 99;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(180deg, #fd7900 -34.44%, #ffcb2a 133.33%);
  border-radius: 40px;
}

.button.is-info.is-outlined:hover,
.button.is-info.is-outlined:focus,
.button.is-info {
  border-radius: 21px;
  border-color: #0d6aca;
  color: #0d6aca;
  background: white;
}

.orangebutton:hover,
.orangebutton:focus,
.orangebutton {
  border-radius: 21px !important;
  border-color: #fd7900 !important;
  color: #fd7900 !important;
  background: white !important;
}
.b-radio.radio input[type="radio"] + .check {
  border: 2px solid #dadada !important;
  /* border-color: #DADADA; */
}
.media-left {
  text-align: center;
}
.media-content {
  position: relative;
}
.image img {
  border-radius: 50%;
}
.level-item {
  margin-right: 0.6rem;
}
i {
  color: white;
  justify-content: center;
}
.circle {
  border-radius: 50%;
  background: #0D6ACA;
  text-align: center;
  width: 30px;
  font-size: 13px;
  height: 30px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}
.circle:hover {
  background: white;
  box-shadow: 0 0 0 1px #0D6ACA;
}
.circle:hover i {
  color: #0D6ACA;
}
article {
  border-radius: 5px;
  background: white;
  padding: 1.8rem;
  position: relative;
  top: 23px;
  height: auto;
}
.underline {
  position: absolute;
  bottom: -20px;
  width: 100%;
  background: rgba(0, 0, 0, 0.25);
  height: 1px;
}
.mb {
  margin-bottom: 5rem !important;
}
.blurprofile .blurcontent {
  filter: blur(3px);
  opacity: 0.5;
}
@media only screen and (max-width: 375px) {
  .media {
    display: block;
  }
}
</style>
<style>
.blurprofile button:hover {
  background: white !important;
  box-shadow: 0 0 0 1px #fd7900 !important;
  color: #fd7900 !important;
}
</style>